import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const useBudgetForcase = (projectId: string | undefined) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-adjustments", projectId],
        queryFn: () => commercialsApi.fetchForecast({ projectId }),
        enabled: !!projectId,
    });

    const project = data?.data?.project;
    const budgets = data?.data?.project?.budgets_monthly;

    const structuredData =
        project && MONTHS.map((month, index) => {
            const row: any = {
                month,
                Actual: { value: project.actuals_monthly?.[index].value, cumulative: project.actuals_cumulative?.[index].value },
                Forecast: { value: project.forecast_monthly?.[index].value, cumulative: project.forecast_cumulative?.[index].value },
                Baseline: { value: project.baseline_monthly?.[index].value, cumulative: project.baseline_cumulative?.[index].value },
                EAC: { value: project.eac_monthly?.[index].value, cumulative: project.eac_cumulative?.[index].value },
                Commitments: { value: project.commitments_monthly?.[index].value, cumulative: project.commitments_cumulative?.[index].value },
                Revised: { value: project.revised_budget_monthly?.[index].value, cumulative: project.revised_budget_cumulative?.[index].value },
                Variation: { value: project.variation_monthly?.[index].value, cumulative: project.variation_cumulative?.[index].value },
            };
            if (budgets && Array.isArray(budgets)) {
                budgets.forEach((b, i) => {
                    const key = `Budget${i + 1}`;
                    row[key] = b.months?.[index]?.total_value ?? 0;
                });
            }

            return row;
        });

    return {
        structuredData,
        isLoading,
        isError,
        error,
    };
};